import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mto_component_tiered_pricing_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mto_component_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  mto_section_guid: fromDatatype.GuidDataFieldInterface;
  qty_range_from: fromDatatype.NumericDatatypeClass;
  qty_range_to: fromDatatype.NumericDatatypeClass;
  unit_price: fromDatatype.NumericDatatypeClass;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.NumericDatatypeClass;
}

export class bl_fi_mto_component_tiered_pricing_RowClass
  implements bl_fi_mto_component_tiered_pricing_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  mto_component_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  mto_section_guid: fromDatatype.GuidDataFieldInterface;
  qty_range_from: fromDatatype.NumericDatatypeClass;
  qty_range_to: fromDatatype.NumericDatatypeClass;
  unit_price: fromDatatype.NumericDatatypeClass;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.NumericDatatypeClass;
}
